import {fetchGet} from "./util";

export const getDashboard = () => {
    return fetchGet(`/dashboard`).then((res) => res);
};

export const getPipelines = (id) => {
    return fetchGet(`/users/${id}/pipelines`).then((res) => res);
};